import { v4 as uuidv4 } from 'uuid'
import { device } from './device'

// traceId，为了防止网络抖动，每次请求生成
export const getTraceId = () => {
  return uuidv4()
}

// 获取埋点事件 eventKey
export const getClickEvent = (event) => {
  if (!event) {
    console.warn('埋点事件错误：', event)
    return {}
  }
  if (typeof event === 'string') {
    return { eventKey: event }
  }
  if (typeof event === 'object') {
    return {
      ...event,
      eventKey: event.name
    }
  }
}

/**
 * 弹窗提示
 * @param data
 */
 export const debugAlert = function (data) {
  if (device.isBrowser) {
    window.alert(data)
  }
}

/**
 * 获取cookie操作
 * @param key
 * @returns {*}
 */
 export const getCookie = function (key) {
  const arr = document.cookie.match(new RegExp(`(^| )${key}=([^;]*)(;|$)`)) || []

  return arr[2] ? decodeURI(arr[2]) : ''
}



// WEBPACK FOOTER //
// ./src/npm/monitor/utils/index.js